import { useTheme } from 'styled-components'
import { Icon, Text } from 'components'
import { Action } from './styles'

export const Vote = ({ post, vote }) => {
  const { colors } = useTheme()
  const currentVote = post.vote?.[0]?.value
  return (
    <Action>
      <Icon
        fill={currentVote === 'up' ? colors('link') : null}
        onClick={() => vote(post, 'up')}
        icon={currentVote === 'up' ? 'arrow-up-bold' : 'arrow-up-bold-outline'}
      />
      <Text size="0.85rem">{post.votes}</Text>
      <Icon
        fill={currentVote === 'down' ? colors('link') : null}
        onClick={() => vote(post, 'down')}
        icon={currentVote === 'down' ? 'arrow-down-bold' : 'arrow-down-bold-outline'}
      />
    </Action>
  )
}
